function getMinDist(widthInDegrees: number, markerWidth: number, mapWidth: number) {
  const MINIMUM_MIN_DIST = 0.000001;
  const minDist = (widthInDegrees * markerWidth) / mapWidth;

  return Math.max(MINIMUM_MIN_DIST, minDist);
}

export default getMinDist;
